// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"style_sectionHeader__sigCM","title":"style_title__3EWXV","hero":"style_hero__1Kroy"};